import { render } from "./h5Photo.vue?vue&type=template&id=47e430e8&scoped=true"
import script from "./h5Photo.vue?vue&type=script&lang=js"
export * from "./h5Photo.vue?vue&type=script&lang=js"

import "./h5Photo.vue?vue&type=style&index=0&id=47e430e8&lang=css"
import "./h5Photo.vue?vue&type=style&index=1&id=47e430e8&scoped=true&lang=scss"

import exportComponent from "D:\\AllProject\\h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e430e8"]])

export default __exports__